import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import { cartoonDataUri, employeePhotoUrl } from './cartoonFace';

export { cartoonDataUri, employeePhotoUrl };

export function CartoonFace({ seed }) {
  return (
    <img
      alt=""
      src={cartoonDataUri(seed)}
      style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
    />
  );
}

CartoonFace.propTypes = {
  seed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export function EmployeePhoto({ code, src, alt, style }) {
  const fallback = cartoonDataUri(code || 'guest');
  const [photo, setPhoto] = useState(src || (code ? employeePhotoUrl(code) : fallback));

  useEffect(() => {
    setPhoto(src || (code ? employeePhotoUrl(code) : fallback));
  }, [src, code, fallback]);

  return <img src={photo} alt={alt} style={style} onError={() => setPhoto(fallback)} />;
}

EmployeePhoto.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
};
